import React from "react";
const InsertPluginIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 19 19", width: "19", height: "19", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.889 5L1 8.89l3.889 3.888.707-.708-3.182-3.18 3.182-3.184zm8.818 7.779l3.89-3.89L13.706 5 13 5.708l3.182 3.181L13 12.072z" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", d: "M11.948 2L7 15.978" }));
var InsertPluginIcon_default = InsertPluginIcon;
export {
  InsertPluginIcon_default as default
};
//# sourceMappingURL=InsertPluginIcon.js.map
